function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}

function isNonEmpty(array) {
  return array.length > 0;
}
function flatten(array) {
  return array.flat(1);
}
function map$1(fn) {
  function mapFn(array) {
    return array.map(fn);
  }
  return mapFn;
}

var array = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isNonEmpty: isNonEmpty,
  flatten: flatten,
  map: map$1
});

/**
 * Singleton instance of Ok<void>. Used to optimize results whose Ok values are
 * void.
 */
var voidOk = Object.freeze({
  kind: "ok",
  value: undefined
});
function ok(value) {
  if (value === undefined) return voidOk;
  return {
    kind: "ok",
    value: value
  };
}
function err(error) {
  return {
    kind: "err",
    error: error
  };
}
function isOk(result) {
  return result === voidOk || result.kind === "ok";
}
function isErr(result) {
  return result !== voidOk && result.kind === "err";
}
/**
 * If all results are Ok (or if results is empty), returns Ok with all the Ok
 * values concatenated into an array. If any result is Err, returns Err with all
 * Err values concatenated into an array.
 *
 * @see {@link all} for use with simple array types.
 */
function allT(results) {
  var values = [];
  var errors = [];
  var _iterator = _createForOfIteratorHelper(results),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var result = _step.value;
      if (isOk(result)) {
        values.push(result.value);
      } else {
        errors.push(result.error);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (isNonEmpty(errors)) {
    return err(errors);
  } else {
    return ok(values);
  }
}

/**
 * If all results are Ok (or if results is empty), returns Ok with all the Ok
 * values concatenated into an array. If any result is Err, returns Err with all
 * Err values concatenated into an array.
 *
 * @see {@link allT} for use with tuple types.
 */
function all(results) {
  return allT(results);
}

/**
 * If all results are Ok (or if results is empty), returns Ok. If any result is
 * Err, returns Err with all Err values concatenated into an array.
 */
function allV(results) {
  var errs = [];
  var _iterator2 = _createForOfIteratorHelper(results),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var result = _step2.value;
      if (isErr(result)) {
        errs.push(result.error);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (isNonEmpty(errs)) {
    return err(errs);
  }
  return voidOk;
}

/**
 * Perform a reduction over an array with a Result-returning reducer. If the
 * reducer returns Ok, its value is used as the next value. If the reducer
 * returns Err, it is returned immediately.
 *
 * flatMapReduce is a short-circuiting equivalent to:
 * ```
 * arr.reduce(
 *   (accRes, current, currentIndex) =>
 *     flatMap((acc) => reducer(acc, current, currentIndex))(accRes),
 *   ok(initVal)
 * )
 * ```
 */
function flatMapReduce(reducer, initVal) {
  return function (arr) {
    var val = ok(initVal);
    for (var i = 0; i < arr.length && isOk(val); ++i) {
      val = reducer(val.value, arr[i], i);
    }
    return val;
  };
}
function map(onOk) {
  return function (result) {
    if (isOk(result)) {
      return ok(onOk(result.value));
    } else {
      return result;
    }
  };
}
function flatMap(onOk) {
  return function (result) {
    if (isOk(result)) {
      return onOk(result.value);
    } else {
      return result;
    }
  };
}
function mapErr(onErr) {
  return function (result) {
    if (isErr(result)) {
      return err(onErr(result.error));
    } else {
      return result;
    }
  };
}
function fromPredicate(refinement, onFalse) {
  return function (value) {
    if (refinement(value)) {
      return ok(value);
    } else {
      return err(onFalse(value));
    }
  };
}

// NOTE: Function overload resolution seems to fail when declared as overloaded
// function type, so a value with a callable type is used instead.
var filterOrElse = function filterOrElse(refinement, onFalse) {
  return function (result) {
    if (isOk(result)) {
      if (refinement(result.value)) {
        return result;
      } else {
        return err(onFalse(result.value));
      }
    } else {
      return result;
    }
  };
};

var result = /*#__PURE__*/Object.freeze({
  __proto__: null,
  voidOk: voidOk,
  ok: ok,
  err: err,
  isOk: isOk,
  isErr: isErr,
  allT: allT,
  all: all,
  allV: allV,
  flatMapReduce: flatMapReduce,
  map: map,
  flatMap: flatMap,
  mapErr: mapErr,
  fromPredicate: fromPredicate,
  filterOrElse: filterOrElse
});

export { _unsupportedIterableToArray as _, _arrayLikeToArray as a, _createForOfIteratorHelper as b, isOk as c, array as d, err as e, isNonEmpty as f, flatMap as g, flatMapReduce as h, isErr as i, filterOrElse as j, mapErr as k, map$1 as l, map as m, all as n, ok as o, flatten as p, allT as q, result as r };
